<template>
  <v-row no-gutters>
    <v-col>
      <v-card height="640" flat>
        <v-card-title>Terms</v-card-title>
        <hr />
        <v-card-subtitle>
          Use of this software is subject to the
          <a 
            href="https://licensing-centre.poweredbypaf.com/files/documents/paf-data-supply-agreement-2019.pdf"
          target="_blank" >Royal Mail PAF License.</a>
        </v-card-subtitle>
        <v-card-subtitle>Use of this software is subject to <a 
            href="https://www.capita.com/purchase-terms"
          target="_blank" >Capita Purchase Terms.</a></v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {};
</script>
<style scoped>
</style>